import {Fragment} from "react";

import Api from "../../Constants/Api";
import "./styles.css";

const Business = (props) => {
    const {data, isResult} = props;
    return (
        <Fragment>
            {
                !isResult ? <p className="app-business-label">درگاه پرداخت اپلیکیشن داپ‌اَپ</p> : null
            }
            <div className="app-business-row px-2">
                <div className="app-business-row-right">
                    <img 
                        className="app-business-row-img"
                        src={`${Api.IMAGE_DOMAIN}${data?.icon}`}
                    />
                    <span>{data?.shop_name}</span>
                </div>
                <span className="app-business-row-left-text">{data?.sub_cat_name}</span>
            </div>
        </Fragment>
    );
};
export default Business;